// extracted by mini-css-extract-plugin
module.exports = {"link":"EventToActLink_link__1HQNO"};